<template lang="">
  <div>
    <section>
      <!--mobdesign-->
      <div class="bg-gradient-to-b from-[#0F2377] to-[#00102F] md:hidden">
        <div class="p-4">
          <a href="/">
            <img
              src="@/assets/footer/footerLogo.svg"
              alt="footerLogo"
              loading="lazy"
              decoding="async"
            />
          </a>
        </div>
        <div
          class="border-[1px] border-solid w-[21rem] relative bottom-2 left-[7%] border-[#EFEFEF] opacity-15"
        ></div>
        <div v-for="(data, index) in footerContent" :key="data.id">
          <div
            class="flex justify-between px-8 py-2"
            @click="toggleTab(data.id)"
            v-if="index < 4"
          >
            <div
              class="text-base cursor-pointer"
              :class="index < 4 ? 'text-[#F8C300] ' : 'text-white '"
            >
              {{ data.heading }}
            </div>
            <div>
              <img
                v-if="activefooterTab == data.id"
                src="@/assets/nav/up.svg"
                class="w-[16px] h-[16px] object-contain text-white"
                alt="up arrow"
              />
              <img
                v-else
                src="@/assets/nav/down.svg"
                class="w-[16px] h-[16px] object-contain text-white"
                alt="down arrow"
              />
            </div>
          </div>
          <div v-if="activefooterTab == data.id" class="flex flex-col">
            <div
              v-for="item in data.content"
              :key="item"
              class="text-white self-start px-[2rem] text-start"
            >
              <template
                v-if="
                  item.title != 'Disclaimer' &&
                  item.title != 'Download Brochure' &&
                  item.title != 'Book an appointment'
                "
              >
                <a :href="item.link" target="_blank">{{ item.title }}</a>
              </template>
              <template v-if="item.title == 'Disclaimer'">
  <p @click="is_disclaimer = true" class="cursor-pointer">Disclaimer</p>
</template>
              <template v-if="item.title == 'Download Brochure'">
  <p @click="is_download_brochure = true" class="cursor-pointer">
    Download Brochure
  </p>
</template>
              <template v-if="item.title == 'Book an appointment'">
  <div
    v-if="videoButton"
    class="fixed bottom-0 left-0 h-full w-full flex items-center justify-center bg-black bg-opacity-60"
    @click="videoButton = false"
  >
    <iframe
      src="https://zipme.at/usdcglobal-meetings"
      name="onlinejain"
      width="350px"
      height="500px"
      style="border: 2px solid #f6f5f4; border-radius: 10px"
      allow="camera *;microphone *;display-capture *"
    ></iframe>
  </div>
  <p @click="videoButton = true" class="cursor-pointer">Book an Appointment</p>
</template>
            </div>
          </div>
        </div>
        <!-- show more & show less mobile -->
        <div class="flex justify-center py-6">
          <div
            class="flex items-center gap-2 bg-[#F8C300] rounded-full py-2 px-4 w-[135px] cursor-pointer"
            v-if="!footerToggle"
            @click="footerToggle = true"
          >
            <span class="text-sm lg:text-[16px] text-black font-bold">
              Show More
            </span>
            <img
              src="@/assets/nav/down_blue.svg"
              class="w-[16px] h-[16px] object-contain"
              alt="left arrow"
            />
          </div>
          <div
            class="flex items-center gap-2 bg-[#F8C300] rounded-full py-2 px-4 w-[135px] cursor-pointer"
            v-else
            @click="footerToggle = false"
          >
            <span class="text-sm lg:text-[16px] text-black font-bold">
              Show Less
            </span>
            <img
              src="@/assets/nav/up_blue.svg"
              class="w-[16px] h-[16px] object-contain"
              alt="up arrow"
            />
          </div>
        </div>
        <div
          class="text-left px-8 mx-auto w-full max-w-7xl pt-[1rem] pb-[2rem]"
          v-show="footerToggle"
        >
          <!-- dynamic content -->
          <!-- dynamic1 -->
          <div v-if="template_tab == '1'">
            <div class="program-category">
              <div
                class="flex justify-between"
                @click="toggleDropdown('degrees')"
              >
                <div>
                  <a href="/all-programs">
                    <h2 class="text-white font-medium text-[14px]">
                      Top Online Degrees
                    </h2>
                  </a>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.degrees"
                    @click="dropdownOpen.degrees != dropdownOpen.degrees"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.degrees != dropdownOpen.degrees"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.degrees"
              >
                <li
                  v-for="(degree, index) in dataSet1.degrees"
                  :key="degree.name"
                >
                  <a
                    :href="degree.url"
                    :title="degree.name"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet1.degrees.length - 1 ? '10px' : '0',
                      borderRight:
                        index !== dataSet1.degrees.length - 1
                          ? '1px solid #ccc'
                          : 'none',
                    }"
                  >
                    {{ degree.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('mbaCourses')"
              >
                <div>
                  <a href="/master-business-administration-online-degree">
                    <h2 class="text-white font-medium text-[14px]">
                      Top Online MBA Programs
                    </h2>
                  </a>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.mbaCourses"
                    @click="dropdownOpen.mbaCourses != dropdownOpen.mbaCourses"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.mbaCourses != dropdownOpen.mbaCourses"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.mbaCourses"
              >
                <li
                  v-for="(program, index) in dataSet1.mbaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    :title="program.name"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet1.mbaPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('mcaCourses')"
              >
                <div>
                  <a href="/masters-computer-application-online-degree">
                    <h2 class="text-white font-medium text-[14px]">
                      Top Online MCA Programs
                    </h2>
                  </a>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.mcaCourses"
                    @click="dropdownOpen.mcaCourses != dropdownOpen.mcaCourses"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.mcaCourses != dropdownOpen.mcaCourses"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.mcaCourses"
              >
                <li
                  v-for="(program, index) in dataSet1.mcaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    :title="program.name"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet1.mcaPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('mcomCourses')"
              >
                <div>
                  <a href="/master-of-commerce-online-degree">
                    <h2 class="text-white font-medium text-[14px]">
                      Top Online M.Com Programs
                    </h2>
                  </a>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.mcomCourses"
                    @click="
                      dropdownOpen.mcomCourses != dropdownOpen.mcomCourses
                    "
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="
                      dropdownOpen.mcomCourses != dropdownOpen.mcomCourses
                    "
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.mcomCourses"
              >
                <li
                  v-for="(program, index) in dataSet1.mcomPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    :title="program.name"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet1.mcomPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('maCourses')"
              >
                <div>
                  <a href="/master-of-arts-online-degree">
                    <h2 class="text-white font-medium text-[14px]">
                      Top Online MA Programs
                    </h2>
                  </a>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.maCourses"
                    @click="dropdownOpen.maCourses != dropdownOpen.maCourses"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.maCourses != dropdownOpen.maCourses"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.maCourses"
              >
                <li
                  v-for="(program, index) in dataSet1.maPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    :title="program.name"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet1.maPrograms.length - 1 ? '10px' : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div> -->

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('bbaCourses')"
              >
                <div>
                  <a href="/bachelor-of-business-administration-online-degree">
                    <h2 class="text-white font-medium text-[14px]">
                      Top Online BBA Programs
                    </h2>
                  </a>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.bbaCourses"
                    @click="dropdownOpen.bbaCourses != dropdownOpen.bbaCourses"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.bbaCourses != dropdownOpen.bbaCourses"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.bbaCourses"
              >
                <li
                  v-for="(program, index) in dataSet1.bbaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    :title="program.name"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet1.bbaPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('bcomCourses')"
              >
                <div>
                  <a href="/bachelor-of-commerce-online-degree">
                    <h2 class="text-white font-medium text-[14px]">
                      Top Online B.Com Programs
                    </h2>
                  </a>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.bcomCourses"
                    @click="
                      dropdownOpen.bcomCourses != dropdownOpen.bcomCourses
                    "
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="
                      dropdownOpen.bcomCourses != dropdownOpen.bcomCourses
                    "
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.bcomCourses"
              >
                <li
                  v-for="(program, index) in dataSet1.bcomPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    :title="program.name"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet1.bcomPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

           <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('bcaCourses')"
              >
                <div>
                  <a href="/bachelor-of-computer-application-online-degree">
                    <h2 class="text-white font-medium text-[14px]">
                      Top Online BCA Programs
                    </h2>
                  </a>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.bcaCourses"
                    @click="
                      dropdownOpen.bcaCourses != dropdownOpen.bcaCourses
                    "
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="
                      dropdownOpen.bcaCourses != dropdownOpen.bcaCourses
                    "
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.bcaCourses"
              >
                <li
                  v-for="(program, index) in dataSet1.bcaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    :title="program.name"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet1.bcaPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <!-- dynamic1 -->

          <!-- dynamic2 -->
          <div v-if="template_tab == '2'">
            <div class="program-category">
              <div
                class="flex justify-between"
                @click="toggleDropdown('degrees')"
              >
                <div>
                  <h2 class="text-white font-medium text-[14px]">
                    Online Master’s Degree
                  </h2>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.degrees"
                    @click="dropdownOpen.degrees != dropdownOpen.degrees"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.degrees != dropdownOpen.degrees"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.degrees"
              >
                <li
                  v-for="(degree, index) in dataSet2.mastersDegrees"
                  :key="degree.name"
                >
                  <a
                    :href="degree.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet2.mastersDegrees.length - 1
                          ? '10px'
                          : '0',
                      borderRight:
                        index !== dataSet2.mastersDegrees.length - 1
                          ? '1px solid #ccc'
                          : 'none',
                    }"
                  >
                    {{ degree.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('bachelorsDegree')"
              >
                <div>
                  <h2 class="text-white font-medium text-[14px]">
                    Online Bachelor’s Degree
                  </h2>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.bachelorsDegree"
                    @click="
                      dropdownOpen.bachelorsDegree !=
                        dropdownOpen.bachelorsDegree
                    "
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="
                      dropdownOpen.bachelorsDegree !=
                        dropdownOpen.bachelorsDegree
                    "
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.bachelorsDegree"
              >
                <li
                  v-for="(program, index) in dataSet2.bachelorDegrees"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet2.bachelorDegrees.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('mbaCourses')"
              >
                <div>
                  <h2 class="text-white font-medium text-[14px]">
                    Online MBA Degree
                  </h2>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.mbaCourses"
                    @click="dropdownOpen.mbaCourses != dropdownOpen.mbaCourses"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.mbaCourses != dropdownOpen.mbaCourses"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.mbaCourses"
              >
                <li
                  v-for="(program, index) in dataSet2.mbaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet2.mbaPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('mcaCourses')"
              >
                <div>
                  <h2 class="text-white font-medium text-[14px]">
                    Online MCA Degree
                  </h2>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.mcaCourses"
                    @click="dropdownOpen.mcaCourses != dropdownOpen.mcaCourses"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.mcaCourses != dropdownOpen.mcaCourses"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.mcaCourses"
              >
                <li
                  v-for="(program, index) in dataSet2.mcaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet2.mcaPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('mcomCourses')"
              >
                <div>
                  <h2 class="text-white font-medium text-[14px]">
                    Online M.Com Degree
                  </h2>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.mcomCourses"
                    @click="
                      dropdownOpen.mcomCourses != dropdownOpen.mcomCourses
                    "
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="
                      dropdownOpen.mcomCourses != dropdownOpen.mcomCourses
                    "
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.mcomCourses"
              >
                <li
                  v-for="(program, index) in dataSet2.mcomPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet2.mcomPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('maCourses')"
              >
                <div>
                  <a href="/master-of-arts-online-degree">
                    <h2 class="text-white font-medium text-[14px]">
                      Top Online MA Programs
                    </h2>
                  </a>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.maCourses"
                    @click="dropdownOpen.maCourses != dropdownOpen.maCourses"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.maCourses != dropdownOpen.maCourses"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.maCourses"
              >
                <li
                  v-for="(program, index) in dataSet2.maPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet2.maPrograms.length - 1 ? '10px' : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div> -->

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('bbaCourses')"
              >
                <div>
                  <h2 class="text-white font-medium text-[14px]">
                    Online BBA Degree
                  </h2>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.bbaCourses"
                    @click="dropdownOpen.bbaCourses != dropdownOpen.bbaCourses"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.bbaCourses != dropdownOpen.bbaCourses"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.bbaCourses"
              >
                <li v-for="program in dataSet2.bbaPrograms" :key="program.name">
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('bcomCourses')"
              >
                <div>
                  <h2 class="text-white font-medium text-[14px]">
                    Online B.com Degree
                  </h2>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.bcomCourses"
                    @click="
                      dropdownOpen.bcomCourses != dropdownOpen.bcomCourses
                    "
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="
                      dropdownOpen.bcomCourses != dropdownOpen.bcomCourses
                    "
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.bcomCourses"
              >
                <li
                  v-for="(program, index) in dataSet2.bcomPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet2.bcomPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('bcaCourses')"
              >
                <div>
                  <h2 class="text-white font-medium text-[14px]">
                    Online BCA Degree
                  </h2>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.bcaCourses"
                    @click="
                      dropdownOpen.bcaCourses != dropdownOpen.bcaCourses
                    "
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="
                      dropdownOpen.bcaCourses != dropdownOpen.bcaCourses
                    "
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.bcaCourses"
              >
                <li
                  v-for="(program, index) in dataSet2.bcaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet2.bcaPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <!-- dynamic2 -->

          <!-- dynamic3 -->
          <div v-if="template_tab == '3'">
            <div class="program-category">
              <div
                class="flex justify-between"
                @click="toggleDropdown('degrees')"
              >
                <div>
                  <h2 class="text-white font-medium text-[14px]">
                    Online Master’s Program
                  </h2>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.degrees"
                    @click="dropdownOpen.degrees != dropdownOpen.degrees"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.degrees != dropdownOpen.degrees"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.degrees"
              >
                <li
                  v-for="(degree, index) in dataSet3.degrees"
                  :key="degree.name"
                >
                  <a
                    :href="degree.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet3.degrees.length - 1 ? '10px' : '0',
                      borderRight:
                        index !== dataSet3.degrees.length - 1
                          ? '1px solid #ccc'
                          : 'none',
                    }"
                  >
                    {{ degree.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('bachelorsDegree')"
              >
                <div>
                  <h2 class="text-white font-medium text-[14px]">
                    Online Bachelors Program
                  </h2>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.bachelorsDegree"
                    @click="
                      dropdownOpen.bachelorsDegree !=
                        dropdownOpen.bachelorsDegree
                    "
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="
                      dropdownOpen.bachelorsDegree !=
                        dropdownOpen.bachelorsDegree
                    "
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.bachelorsDegree"
              >
                <li
                  v-for="(program, index) in dataSet3.bachelorsDegree"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet3.bachelorsDegree.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('mbaCourses')"
              >
                <div>
                  <a href="/master-business-administration-online-degree">
                    <h2 class="text-white font-medium text-[14px]">
                      Top Online MBA Programs
                    </h2>
                  </a>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.mbaCourses"
                    @click="dropdownOpen.mbaCourses != dropdownOpen.mbaCourses"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.mbaCourses != dropdownOpen.mbaCourses"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.mbaCourses"
              >
                <li
                  v-for="(program, index) in dataSet3.mbaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet3.mbaPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('mcaCourses')"
              >
                <div>
                  <a href="/masters-computer-application-online-degree">
                    <h2 class="text-white font-medium text-[14px]">
                      Top Online MCA Programs
                    </h2>
                  </a>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.mcaCourses"
                    @click="dropdownOpen.mcaCourses != dropdownOpen.mcaCourses"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.mcaCourses != dropdownOpen.mcaCourses"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.mcaCourses"
              >
                <li
                  v-for="(program, index) in dataSet3.mcaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet3.mcaPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('mcomCourses')"
              >
                <div>
                  <h2 class="text-white font-medium text-[14px]">
                    Top Online M. Com Programs
                  </h2>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.mcomCourses"
                    @click="
                      dropdownOpen.mcomCourses != dropdownOpen.mcomCourses
                    "
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="
                      dropdownOpen.mcomCourses != dropdownOpen.mcomCourses
                    "
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.mcomCourses"
              >
                <li
                  v-for="(program, index) in dataSet3.mcomPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet3.mcomPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>
            <!-- <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('maCourses')"
              >
                <div>
                  <a href="/master-of-arts-online-degree">
                    <h2 class="text-white font-medium text-[14px]">
                      Top Online MA Programs
                    </h2>
                  </a>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.maCourses"
                    @click="dropdownOpen.maCourses != dropdownOpen.maCourses"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.maCourses != dropdownOpen.maCourses"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.maCourses"
              >
                <li
                  v-for="(program, index) in dataSet3.maPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet3.maPrograms.length - 1 ? '10px' : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div> -->

            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('bbaCourses')"
              >
                <div>
                  <a href="/bachelor-of-business-administration-online-degree">
                    <h2 class="text-white font-medium text-[14px]">
                      Top Online BBA Programs
                    </h2>
                  </a>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.bbaCourses"
                    @click="dropdownOpen.bbaCourses != dropdownOpen.bbaCourses"
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="dropdownOpen.bbaCourses != dropdownOpen.bbaCourses"
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.bbaCourses"
              >
                <li
                  v-for="(program, index) in dataSet3.bbaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet3.bbaPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>
            <div class="program-category pt-8">
              <div
                class="flex justify-between"
                @click="toggleDropdown('bcomCourses')"
              >
                <div>
                  <h2 class="text-white font-medium text-[14px]">
                    Top Online B.Com Programs
                  </h2>
                </div>
                <div>
                  <img
                    v-if="!dropdownOpen.bcomCourses"
                    @click="
                      dropdownOpen.bcomCourses != dropdownOpen.bcomCourses
                    "
                    src="@/assets/nav/down.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                  <img
                    v-else
                    @click="
                      dropdownOpen.bcomCourses != dropdownOpen.bcomCourses
                    "
                    src="@/assets/nav/up.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <ul
                class="pt-3 flex gap-1 flex-wrap"
                v-show="dropdownOpen.bcomCourses"
              >
                <li
                  v-for="(program, index) in dataSet3.bcomPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[12px] font-normal"
                    :style="{
                      paddingRight:
                        index !== dataSet3.bcomPrograms.length - 1
                          ? '10px'
                          : '0',
                    }"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <!-- dynamic3 -->
          <!-- dynamic content -->
        </div>
        <!-- mobile footer social media links -->
        <div class="flex flex-col gap-5 pb-16">
          <div class="m-auto flex justify-center gap-x-4">
            <a href="https://twitter.com/JainOnlineEdu" target="blank">
              <div
                class="rounded-full w-[2rem] h-[2rem] bg-[#F8C300] flex items-center justify-center"
              >
                <img
                  src="@/assets/footer/x.svg"
                  alt="x"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </a>
            <a
              href="https://www.facebook.com/JAINOnlineEducation/"
              target="blank"
            >
              <div
                class="rounded-full w-[2rem] h-[2rem] bg-[#F8C300] flex items-center justify-center"
              >
                <img
                  src="@/assets/footer/facebook.svg"
                  alt="facebook"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </a>
            <a
              href="https://www.instagram.com/jainonlineofficial"
              target="blank"
            >
              <div
                class="rounded-full w-[2rem] h-[2rem] bg-[#F8C300] flex items-center justify-center"
              >
                <img
                  src="@/assets/footer/instagram.svg"
                  alt="instagram"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </a>
            <a
              href="https://www.linkedin.com/company/jain-online"
              target="blank"
            >
              <div
                class="rounded-full w-[2rem] h-[2rem] bg-[#F8C300] flex items-center justify-center"
              >
                <img
                  src="@/assets/footer/linkedin.svg"
                  alt="linkedin"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </a>
            <a
              href="https://www.youtube.com/c/jainonlineofficial"
              target="blank"
            >
              <div
                class="rounded-full w-[2rem] h-[2rem] bg-[#F8C300] flex items-center justify-center"
              >
                <img
                  src="@/assets/footer/youtube.svg"
                  alt="youtube"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </a>
          </div>
          <div class="text-xs text-white">
            © 2025 JAIN (Deemed-to-be University)
          </div>
        </div>
      </div>

      <!--mobdesign-->
      <!--desktop desing-->
      <div
        class="hidden md:block bg-gradient-to-b from-[#0F2377] to-[#00102F] m-auto"
      >
        <div class="flex gap-5 justify-around pb-[2rem] pt-[2rem]">
          <div class="p-2">
            <div class="w-[10rem] lg:w-max">
              >
              <a href="/">
                <img
                  src="@/assets/footer/footerLogo.svg"
                  alt="footerImg"
                  loading="lazy"
                  decoding="async"
                />
              </a>
            </div>
            <div class="flex gap-x-3 mt-6 pl-2">
              <a href="https://twitter.com/JainOnlineEdu" target="blank">
                <div
                  class="rounded-full w-[1.5rem] lg:w-[2rem] h-[1.5rem] lg:h-[2rem] bg-[#F8C300] flex items-center justify-center"
                >
                  <img
                    src="@/assets/footer/x.svg"
                    alt="x"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </a>
              <a
                href="https://www.facebook.com/JAINOnlineEducation/"
                target="blank"
              >
                <div
                  class="rounded-full w-[1.5rem] lg:w-[2rem] h-[1.5rem] lg:h-[2rem] bg-[#F8C300] flex items-center justify-center"
                >
                  <img
                    src="@/assets/footer/facebook.svg"
                    alt="facebook"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </a>
              <a
                href="https://www.instagram.com/jainonlineofficial"
                target="blank"
              >
                <div
                  class="rounded-full w-[1.5rem] lg:w-[2rem] h-[1.5rem] lg:h-[2rem] bg-[#F8C300] flex items-center justify-center"
                >
                  <img
                    src="@/assets/footer/instagram.svg"
                    alt="instagram"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </a>
              <a
                href="https://www.linkedin.com/company/jain-online"
                target="blank"
              >
                <div
                  class="rounded-full w-[1.5rem] lg:w-[2rem] h-[1.5rem] lg:h-[2rem] bg-[#F8C300] flex items-center justify-center"
                >
                  <img
                    src="@/assets/footer/linkedin.svg"
                    alt="linkedin"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </a>

              <a
                href="https://www.youtube.com/c/jainonlineofficial"
                target="blank"
              >
                <div
                  class="rounded-full w-[1.5rem] lg:w-[2rem] h-[1.5rem] lg:h-[2rem] bg-[#F8C300] flex items-center justify-center"
                >
                  <img
                    src="@/assets/footer/youtube.svg"
                    alt="youtube"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </a>
            </div>
          </div>
          <div class="pt-2 pl-2">
            <h2
              class="text-[#F8C300] font-semibold text-sm lg:text-lg text-start"
            >
              JAIN Online
            </h2>
            <a
              href="/all-programs"
              @click="
                handleLinkClick(
                  'Programs',
                  'https://onlinejain.com/all-programs',
                  'JAIN Online',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium mt-2 text-xs lg:text-base"
              >
                Programs
              </p>
            </a>
            <a
              href="/about-us"
              class="cursor-pointer"
              @click="
                handleLinkClick(
                  'About Us',
                  'https://onlinejain.com/about-us',
                  'JAIN Online',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                About Us
              </p>
            </a>
            <a
              href="/blogs"
              class="cursor-pointer"
              @click="
                handleLinkClick(
                  'Blogs',
                  'https://onlinejain.com/blogs',
                  'JAIN Online',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                Blogs
              </p>
            </a>
            <a
              href="/testimonial"
              class="cursor-pointer"
              @click="
                handleLinkClick(
                  'Testimonials',
                  'https://onlinejain.com/testimonial',
                  'JAIN Online',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                Testimonials
              </p>
            </a>
            <a
              href="/scholarships"
              class="cursor-pointer"
              @click="
                handleLinkClick(
                  'Scholarships',
                  'https://onlinejain.com/scholarships',
                  'JAIN Online',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                Scholarships
              </p>
            </a>
            <a
              href="/news-media"
              class="cursor-pointer"
              @click="
                handleLinkClick(
                  'News & Media',
                  'https://onlinejain.com/news-media',
                  'JAIN Online',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                News & Media
              </p>
            </a>
            <a
              href="https://referral.onlinejain.com/"
              target="_blank"
              @click="
                handleLinkClick(
                  'Refer a friend',
                  'https://referral.onlinejain.com/',
                  'JAIN Online',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                Refer a Friend
              </p>
            </a>
            <a
              href="/micro-credentials-online-courses/"
              @click="
                handleLinkClick(
                  'Micro Credential',
                  'https://onlinejain.com/micro-credentials-online-courses/',
                  'JAIN Online',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                Micro Credential
              </p>
            </a>
          </div>
          <div class="pt-2 ml-4">
            <h2
              class="text-[#F8C300] font-semibold text-sm lg:text-lg text-start"
            >
              Contact Us
            </h2>
            <div
              v-if="videoButton"
              class="fixed bottom-0 left-0 h-full w-full flex items-center justify-center bg-black bg-opacity-60"
              @click="videoButton = false"
            >
              <iframe
                src="https://zipme.at/usdcglobal-meetings"
                name="onlinejain"
                width="350px"
                height="500px"
                style="border: 2px solid #f6f5f4; border-radius: 10px"
                allow="camera *;microphone *;display-capture *"
              ></iframe>
            </div>

            <p
              class="text-start text-white font-medium mt-2 text-xs lg:text-base cursor-pointer"
              @click="
                videoButton = true;
                handleBookAppointment();
              "
            >
              Book an Appointment
            </p>
            <a
              href="tel:+919240013644"
              target="blank"
              @click="
                handleLinkClick(
                  'Call Us',
                  'tel:+919240013644',
                  'Contact Us',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                Call Us
              </p>
            </a>
            <a
              href="/contact-us"
              class="cursor-pointer"
              @click="
                handleLinkClick(
                  'Visit Us',
                  'https://onlinejain.com/contact-us',
                  'Contact Us',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                Visit Us
              </p>
            </a>
          </div>
          <div class="pt-2 ml-2">
            <h2
              class="text-[#F8C300] font-semibold text-sm lg:text-lg text-start"
            >
              Online Support
            </h2>
            <p
              @click="
                is_download_brochure = true;
                handleDownloadBrochure();
                pushBrochureDownloadDataLayer({
                  electiveTitle: 'Overall Brochure',
                  ctaSection: 'Footer',
                });
              "
              class="text-start text-white font-medium mt-2 text-xs lg:text-base cursor-pointer"
            >
              Download Brochure
            </p>
            <a
              href="https://onlinejain.com/lp/apna-advantage/"
              target="_blank"
              @click="
                handleLinkClick(
                  'Apna Advantage',
                  'https://onlinejain.com/lp/apna-advantage/',
                  'Apna Advantage',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                Apna Advantage
              </p>
            </a>
            <a
              href="https://support.onlinejain.com/"
              target="_blank"
              @click="
                handleLinkClick(
                  'Student Support',
                  'https://support.onlinejain.com/',
                  'Online Support',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                Student Support
              </p>
            </a>
            <a
              href="/grievance-redressal"
              class="cursor-pointer"
              @click="
                handleLinkClick(
                  'Grievance Redressal',
                  'https://onlinejain.com/grievance-redressal',
                  'Online Support',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                Grievance Redressal
              </p>
            </a>
            <a
              href="/notifications"
              class="cursor-pointer"
              @click="
                handleLinkClick(
                  'Notifications',
                  'https://onlinejain.com/notifications',
                  'Online Support',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                Notifications
              </p>
            </a>
            <a
              href="/faqs"
              class="cursor-pointer"
              @click="
                handleLinkClick(
                  'FAQs',
                  'https://onlinejain.com/faqs',
                  'Online Support',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                FAQs
              </p>
            </a>
          </div>
          <div class="pt-2 ml-2">
            <h2
              class="text-[#F8C300] font-semibold text-sm lg:text-lg text-start"
            >
              Other Useful Links
            </h2>
            <a
              href="/mandatory-disclosures"
              class="cursor-pointer"
              @click="
                handleLinkClick(
                  'Mandatory Disclosures',
                  'https://onlinejain.com/mandatory-disclosures',
                  'Other Useful Links',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium mt-2 text-xs lg:text-base"
              >
                Mandatory Disclosures
              </p>
            </a>
            <a
              href="https://api.onlinejain.com/media/DEB-Public-Notice-Precautions-to-be-taken-by-students.pdf"
              target="_blank"
              @click="
                handleLinkClick(
                  'Public Notice',
                  'https://api.onlinejain.com/media/DEB-Public-Notice-Precautions-to-be-taken-by-students.pdf',
                  'Other Useful Links',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                Public Notice
              </p>
            </a>
            <a
              href="/privacy-policy"
              class="cursor-pointer"
              @click="
                handleLinkClick(
                  'Policies',
                  'https://onlinejain.com/privacy-policy',
                  'Other Useful Links',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium mt-2 text-xs lg:text-base"
              >
                Privacy Policy
              </p>
            </a>
            <a
              href="/refund-policy"
              class="cursor-pointer"
              @click="
                handleLinkClick(
                  'Refund Policy',
                  'https://onlinejain.com/refund-policy',
                  'Other Useful Links',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium mt-2 text-xs lg:text-base"
              >
                Refund Policy
              </p>
            </a>
            <a
              href="https://api.onlinejain.com/media/JAIN-Online-TnC-docx.pdf"
              target="_blank"
              @click="
                handleLinkClick(
                  'Terms & Conditions',
                  'https://api.onlinejain.com/media/JAIN-Online-TnC-docx.pdf',
                  'Other Useful Links',
                  $event
                )
              "
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                Terms & Conditions
              </p>
            </a>
            <!-- <a
              href="https://api.onlinejain.com/media/DEB-Public-Notice-Precautions-to-be-taken-by-students.pdf"
              target="_blank"
            >
              <p
                class="text-start text-white font-medium text-xs lg:text-base mt-2"
              >
                Public Notice
              </p>
            </a> -->
            <p
              @click="
                is_disclaimer = true;
                handleLinkClick(
                  'Disclaimer',
                  'Disclaimer',
                  'Other Useful Links',
                  $event
                );
              "
              class="text-start text-white font-medium text-xs lg:text-base mt-2 cursor-pointer"
            >
              Disclaimer
            </p>
          </div>
        </div>

        <hr class="h-px my-8 mx-8 bg-gray-200 border-0 dark:bg-gray-600" />
        <div class="flex justify-center">
          <div
            class="flex gap-2 bg-[#F8C300] rounded-full py-2 px-4 w-[150px] cursor-pointer"
            v-if="!footerToggle"
            @click="footerToggle = true"
          >
            <span class="text-sm lg:text-[16px] text-black font-bold">
              Show More
            </span>
            <img
              src="@/assets/nav/down_blue.svg"
              class="w-[16px] h-[16px] object-contain m-auto"
              alt="down arrow"
            />
          </div>
          <div
            class="flex gap-2 bg-[#F8C300] rounded-full py-2 px-4 w-[150px] cursor-pointer"
            v-else
            @click="footerToggle = false"
          >
            <span class="text-sm lg:text-[16px] text-black font-bold">
              Show Less
            </span>
            <img
              src="@/assets/nav/up_blue.svg"
              class="w-[16px] h-[16px] m-auto object-contain"
              alt="up arrow"
            />
          </div>
        </div>
        <div
          class="text-left mx-auto w-full max-w-7xl pb-[2rem]"
          v-show="footerToggle"
        >
          <!-- dynamic content -->
          <!-- dynamic1 -->
          <div v-if="template_tab == '1'">
            <div class="program-category">
              <a href="/all-programs">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online Degrees
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(degree, index) in dataSet1.degrees"
                  :key="degree.name"
                >
                  <a
                    :href="degree.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet1.degrees.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ degree.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <a href="/master-business-administration-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online MBA Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet1.mbaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet1.mbaPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <a href="/masters-computer-application-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online MCA Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet1.mcaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet1.mcaPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <a href="/master-of-commerce-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online M.Com Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet1.mcomPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet1.mcomPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- <div class="program-category pt-8">
              <a href="/master-of-arts-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online MA Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet1.maPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet1.maPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div> -->

            <div class="program-category pt-8">
              <a href="/bachelor-of-business-administration-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online BBA Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet1.bbaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet1.bbaPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <a href="/bachelor-of-commerce-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online B.Com Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet1.bcomPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet1.bcomPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

           <div class="program-category pt-8">
              <a href="/bachelor-of-computer-application-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online BCA Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet1.bcaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet1.bcaPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <!-- dynamic1 -->

          <!-- dynamic2 -->
          <div v-if="template_tab == '2'">
            <div class="program-category">
              <a href="/all-programs">
                <h2 class="text-white font-bold text-[16px]">
                  Online Master’s Degree
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(degree, index) in dataSet2.mastersDegrees"
                  :key="degree.name"
                >
                  <a
                    :href="degree.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet2.mastersDegrees.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ degree.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <a href="/all-programs">
                <h2 class="text-white font-bold text-[16px]">
                  Online Bachelor’s Degree
                </h2>
              </a>

              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet2.bachelorDegrees"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet2.bachelorDegrees.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <a href="/master-business-administration-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Online MBA Degree
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet2.mbaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet2.mbaPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <a href="/masters-computer-application-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Online MCA Degree
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet2.mcaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet2.mcaPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <a href="/master-of-commerce-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Online M.Com Degree
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet2.mcomPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet2.mcomPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- <div class="program-category pt-8">
              <a href="/master-of-arts-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Online MA Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet2.maPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet2.maPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div> -->

            <div class="program-category pt-8">
              <a href="/bachelor-of-business-administration-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Online BBA Degree
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet2.bbaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet2.bbaPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>
            <div class="program-category pt-8">
              <a href="/bachelor-of-business-administration-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Online BCA Degree
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet2.bcaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet2.bcaPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <a href="/bachelor-of-commerce-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Online B.com Degree
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet2.bcomPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet2.bcomPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <!-- dynamic2 -->

          <!-- dynamic3 -->
          <div v-if="template_tab == '3'">
            <div class="program-category">
              <a href="/all-programs">
                <h2 class="text-white font-bold text-[16px]">
                  Online Master’s Program
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(degree, index) in dataSet3.degrees"
                  :key="degree.name"
                >
                  <a
                    :href="degree.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet3.degrees.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ degree.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <a href="/all-programs">
                <h2 class="text-white font-bold text-[16px]">
                  Online Bachelors Program
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet3.bachelorDegrees"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet3.bachelorDegrees.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <a href="/master-business-administration-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online MBA Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet3.mbaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet3.mbaPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <a href="/masters-computer-application-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online MCA Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet3.mcaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet3.mcaPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <a href="/master-of-commerce-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online M. Com Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet3.mcomPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal"
                    :class="[
                      index + 1 < dataSet3.mcomPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- <div class="program-category pt-8">
              <a href="/master-of-arts-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online MA Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet3.maPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet3.maPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div> -->

            <div class="program-category pt-8">
              <a href="/bachelor-of-business-administration-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online BBA Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet3.bbaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet3.bbaPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="program-category pt-8">
              <a href="/bachelor-of-commerce-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online B. Com Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet3.bcomPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet3.bcomPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>
            <div class="program-category pt-8">
              <a href="/bachelor-of-computer-application-online-degree">
                <h2 class="text-white font-bold text-[16px]">
                  Top Online BCA Programs
                </h2>
              </a>
              <ul class="pt-1 flex gap-1 flex-wrap">
                <li
                  v-for="(program, index) in dataSet1.bcaPrograms"
                  :key="program.name"
                >
                  <a
                    :href="program.url"
                    class="text-white text-[14px] font-normal px-1"
                    :class="[
                      index + 1 < dataSet1.bcaPrograms.length
                        ? 'border-r border-white'
                        : '',
                    ]"
                  >
                    {{ program.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <!-- dynamic3 -->
          <!-- dynamic content -->
        </div>
        <div class="text-xs mt-6 pb-4 text-white">
          © 2025 JAIN (Deemed-to-be University)
        </div>
      </div>
      <!--desktop desing-->
    </section>
    <DisclaimerVue
      v-if="is_disclaimer"
      @close-disclaimer="is_disclaimer = false"
    />
    <!-- <DownloadBrochureVue
      v-show="is_download_brochure == true"
      @close-button="is_download_brochure = false"
    /> -->
    <BrochureView
      v-show="is_download_brochure == true"
      @close-button="is_download_brochure = false"
    />
  </div>
</template>
<script>
import { defineAsyncComponent } from "vue";
const DisclaimerVue = defineAsyncComponent(() =>
  import(/* webpackChunkName: "disclaimer" */ "@/components/Disclaimer.vue")
);
// const DownloadBrochureVue = defineAsyncComponent(() =>
//   import(/* webpackChunkName: "brochure" */ "@/components/DownloadBrochure.vue")
// );
const BrochureView = defineAsyncComponent(() =>
  import(/* webpackChunkName: "brochure" */ "@/components/BrochureView.vue")
);
export default {
  name: "DynamicfooterView",
  data() {
    return {
      is_disclaimer: false,
      is_download_brochure: false,
      activefooterTab: null,
      videoButton: false,
      footerToggle: false,
      template_tab: "1",
      dropdownOpen: {
        degrees: false,
        mbaCourses: false,
        mcaCourses: false,
        mcomCourses: false,
        maCourses: false,
        bbaCourses: false,
        bcomCourses: false,
        bachelorsDegree: false,
      },
      template_url_list: [
        { url: "/", temp_tab: "1" },
        { url: "/master-business-administration-online-degree", temp_tab: "1" },
        { url: "/online-mba/banking-and-finance", temp_tab: "1" },
        {
          url: "/online-mba/business-intelligence-and-analytics",
          temp_tab: "1",
        },
        { url: "/online-mba/data-science", temp_tab: "1" },
        { url: "/online-mba/digital-finance", temp_tab: "1" },
        { url: "/online-mba/entrepreneurship-and-leadership", temp_tab: "1" },
        { url: "/online-mba/digital-marketing-and-ecommerce", temp_tab: "1" },
        { url: "/online-mba/finance", temp_tab: "1" },
        { url: "/online-mba/finance-and-marketing", temp_tab: "1" },
        { url: "/online-mba/general-management", temp_tab: "1" },
        { url: "/online-mba/healthcare-management", temp_tab: "1" },
        {
          url: "/online-mba/logistic-and-supply-chain-management",
          temp_tab: "1",
        },
        //{
        //  url: "/online-mba/sports-management",
        //  temp_tab: "1",
        //},
        { url: "/online-mba/hr-finance", temp_tab: "1" },
        { url: "/online-mba/information-technology", temp_tab: "1" },
        { url: "/online-mba/international-finance", temp_tab: "1" },
        { url: "/online-mba/marketing", temp_tab: "1" },
        { url: "/online-mba/hr-marketing", temp_tab: "1" },
        { url: "/online-mba/project-management", temp_tab: "1" },
        // { url: "/online-mba/strategic-finance", temp_tab: "1" },
        {
          url: "/online-mba/strategic-human-resource-management",
          temp_tab: "1",
        },
        { url: "/online-mba/systems-and-opertaions", temp_tab: "1" },
        { url: "/online-mba/human-resources-management", temp_tab: "1" },
        { url: "/online-bachelors-degree", temp_tab: "1" },
        { url: "/online-masters-degree", temp_tab: "1" },

        { url: "/online-mcom/international-finance", temp_tab: "2" },
        {
          url: "/online-mcom/professional-accounting-and-finance",
          temp_tab: "2",
        },
        { url: "/online-mca/artificial-intelligence", temp_tab: "2" },
        { url: "/online-mca/cloud-computing", temp_tab: "2" },
        { url: "/online-mca/computer-science-and-it", temp_tab: "2" },
        { url: "/online-mca/cyber-security", temp_tab: "2" },
        { url: "/online-mca/data-analytics", temp_tab: "2" },
        { url: "/online-mca/data-science", temp_tab: "2" },
        { url: "/online-mca/full-stack-development", temp_tab: "2" },
        { url: "/master-of-commerce-online-degree", temp_tab: "2" },
        { url: "/masters-computer-application-online-degree", temp_tab: "2" },

        {
          url: "/bachelor-of-business-administration-online-degree",
          temp_tab: "3",
        },
        { url: "/online-bba/data-science-and-analytics", temp_tab: "3" },
        { url: "/online-bba/digital-marketing", temp_tab: "3" },
        {
          url: "/online-bba/engineering-and-project-management",
          temp_tab: "3",
        },
        { url: "/online-bba/event-management", temp_tab: "3" },
        { url: "/online-bba/finance", temp_tab: "3" },
        { url: "/online-bba/healthcare-management", temp_tab: "3" },
        { url: "/online-bba/human-resources-management", temp_tab: "3" },
        { url: "/online-bba/marketing", temp_tab: "3" },
        { url: "/bachelor-of-commerce-online-degree", temp_tab: "3" },
        { url: "/online-bcom/accounting-and-finance", temp_tab: "3" },
        { url: "/online-bcom/corporate-accounting", temp_tab: "3" },
        {
          url: "/online-bcom/international-finance-and-accounting",
          temp_tab: "3",
        },
      ],
      footerContent: [
        {
          id: "tab1",
          heading: "JAIN Online",
          content: [
            { title: "Programs", link: "/all-programs/" },
            { title: "About Us", link: "/about-us/" },
            { title: "Blogs", link: "/blogs" },
            { title: "Testimonials", link: "/testimonial/" },
            { title: "Scholarships", link: "/scholarships/" },
            { title: "News & Media", link: "/news-media/" },
            {
              title: "Refer a Friend",
              link: "https://referral.onlinejain.com/",
            },
            {
              title: "Micro Credential",
              link: "/micro-credentials-online-courses/",
            },
          ],
        },
        {
          id: "tab2",
          heading: "Contact Us",
          content: [
            { title: "Book an appointment", link: "" },
            { title: "Call Us", link: "tel:+919240013644" },
            { title: "Visit Us", link: "/contact-us/" },
          ],
        },
        {
          id: "tab3",
          heading: "Online Support",
          content: [
            { title: "Download Brochure", link: "" },
            {
              title: "Apna Advantage",
              link: " https://onlinejain.com/lp/apna-advantage/",
            },
            {
              title: "Student Support",
              link: "https://support.onlinejain.com/",
            },
            { title: "Grievance Redressal", link: "/grievance-redressal/" },
            { title: "Notifications", link: "/notifications/" },
            { title: "FAQs", link: "/faqs/" },
          ],
        },

        {
          id: "tab4",
          heading: "Other Useful Links",
          content: [
            { title: "Mandatory Disclosures", link: "/mandatory-disclosures" },

            { title: "Policies", link: "/privacy-policy/" },
            {
              title: "Terms & Conditions",
              link: "https://api.onlinejain.com/media/JAIN-Online-TnC-docx.pdf",
            },

            {
              title: "Public Notice",
              link: "https://api.onlinejain.com/media/DEB-Public-Notice-Precautions-to-be-taken-by-students.pdf",
            },
            // {
            //   title: 'Notice',
            //   link:
            //     'https://api.onlinejain.com/media/DEB-Public-Notice-Precautions-to-be-taken-by-students.pdf',
            // },
            { title: "Disclaimer", link: "" },
          ],
        },
      ],
      dataSet1: {
        degrees: [
          {
            name: "Master of Business Administration",
            url: "/master-business-administration-online-degree",
          },
          {
            name: "Master of Computer Application",
            url: "/masters-computer-application-online-degree",
          },
          {
            name: "Master of Commerce",
            url: "/master-of-commerce-online-degree",
          },
          {
            name: "Master of Arts",
            url: "/master-of-arts-online-degree",
          },

          {
            name: "Bachelor of Business Administration",
            url: "/bachelor-of-business-administration-online-degree",
          },
          {
            name: "Bachelor of Commerce",
            url: "/bachelor-of-commerce-online-degree",
          },
          {
            name: "Bachelor of Computer Application ",
            url: "/bachelor-of-computer-application-online-degree",
          },
        ],
        mbaPrograms: [
          { name: "MBA in Finance", url: "/online-mba/finance" },
          { name: "MBA in Marketing", url: "/online-mba/marketing" },
          {
            name: "MBA in Banking and Finance",
            url: "/online-mba/banking-and-finance",
          },
          {
            name: "MBA in Finance and Marketing",
            url: "/online-mba/finance-and-marketing",
          },
          {
            name: "MBA in International Finance (Accredited by ACCA, UK)",
            url: "/online-mba/international-finance",
          },
          {
            name: "MBA in Data Science and Analytics",
            url: "/online-mba/data-science",
          },
          {
            name: "MBA in Healthcare Management",
            url: "/online-mba/healthcare-management",
          },
          {
            name: "MBA in Digital Marketing and E-Commerce",
            url: "/online-mba/digital-marketing-and-ecommerce",
          },
          {
            name: "MBA in Human Resource Management",
            url: "/online-mba/human-resources-management",
          },
          {
            name: "MBA in Logistics and Supply Chain Management",
            url: "/online-mba/logistic-and-supply-chain-management",
          },
          {
            name: "MBA in Systems and Operations Management",
            url: "/online-mba/systems-and-operations",
          },
          {
            name: "MBA in Project Management",
            url: "/online-mba/project-management",
          },
          {
            name: "MBA in Business Intelligence and Analytics",
            url: "/online-mba/business-intelligence-and-analytics",
          },
          {
            name: "MBA in Human Resource Management and Finance",
            url: "/online-mba/hr-finance",
          },
          {
            name: "MBA in Information Technology Management",
            url: "/online-mba/information-technology",
          },
          {
            name: "MBA in General Management",
            url: "/online-mba/general-management",
          },
          // {
          //   name: "MBA in Strategic Finance (Accredited by CPA, US + CMA, US)",
          //   url: "/online-mba/strategic-finance",
          // },
          {
            name: "MBA in Artificial Intelligence Course",
            url: "/online-mba/artificial-intelligence",
          },
          {
            name: "MBA in Marketing and Human Resource Management",
            url: "/online-mba/hr-marketing",
          },
          {
            name: "MBA in Entrepreneurship and Leadership",
            url: "/online-mba/entrepreneurship-and-leadership",
          },
          //{
          //  name: "MBA Sports Management",
          //  url: "/online-mba/sports-management",
          //},
          {
            name: "MBA in Retail Banking Operations",
            url: "/online-mba/retail-banking-operations",
          },
        ],
        mcaPrograms: [
          { name: "MCA in Cyber Security", url: "/online-mca/cyber-security" },
          { name: "MCA in Data Science", url: "/online-mca/data-science" },
          {
            name: "MCA in Artificial Intelligence",
            url: "/online-mca/artificial-intelligence",
          },
          {
            name: "MCA in Computer Science and IT",
            url: "/online-mca/computer-science-and-it",
          },
          {
            name: "MCA in Full Stack Development",
            url: "/online-mca/full-stack-development",
          },
          {
            name: "MCA in Cloud Computing",
            url: "/online-mca/cloud-computing",
          },
          {
            name: "MCA in Data Analytics (Accredited by IoA, UK)",
            url: "/online-mca/data-analytics",
          },
        ],
        mcomPrograms: [
          {
            name: "M.Com in Accounting and Finance",
            url: "/online-mcom/accounting-and-finance",
          },
          {
            name: "M.Com in International Finance (Accredited by ACCA, UK)",
            url: "/online-mcom/international-finance",
          },
          {
            name: "M.Com In Professional Accounting and Finance (Accredited by CPA, US)",
            url: "/online-mcom/professional-accounting-and-finance",
          },
        ],
        // maPrograms: [
        //   {
        //     name: "MA in English",
        //     url: "/online-ma/english",
        //   },
        //   {
        //     name: "MA in Economics",
        //     url: "/online-ma/economics",
        //   },
        //   {
        //     name: "MA in Public Policy",
        //     url: "/online-ma/public-policy",
        //   },
        // ],
        bbaPrograms: [
          { name: "BBA in Marketing", url: "/online-bba/marketing" },
          { name: "BBA in Finance", url: "/online-bba/finance" },
          {
            name: "BBA in Human Resources ",
            url: "/online-bba/human-resources-management",
          },
          {
            name: "BBA in Digital Marketing",
            url: "/online-bba/digital-marketing",
          },
          {
            name: "BBA in Data Science and Analytics ",
            url: "/online-bba/data-science-and-analytics ",
          },
          {
            name: "BBA in Engineering and Project Management",
            url: "/online-bba/engineering-and-project-management",
          },
        ],
        bcaPrograms: [
          {
            name: "BCA in Computer Science & Information Technology",
            url: "/online-bca/computer-science-and-information-technology",
          },
          {
            name: "BCA in Artificial Intelligence",
            url: "/online-bca/artificial-Intelligence",
          },
          {
            name: " BCA in Cyber Security",
            url: "/online-bca/cyber-security",
          },
          {
            name: "BCA in Data Science & Analytics",
            url: "/online-bca/data-science-and-analytics",
          },
          {
            name: "BCA in Cloud Computing",
            url: "/online-bca/cloud-computing",
          },
        ],
        bcomPrograms: [
          {
            name: "B.com in Accounting and Finance",
            url: "/online-bcom/accounting-and-finance",
          },
          {
            name: "B.com in International Finance and Accounting (Accredited by ACCA, UK)",
            url: "/online-bcom/international-finance-and-accounting",
          },
          {
            name: "B.com in Corporate Accounting",
            url: "/online-bcom/corporate-accounting",
          },
        ],
      },
      dataSet2: {
        mastersDegrees: [
          {
            name: "Online Master of Business Administration",
            url: "/master-business-administration-online-degree",
          },
          {
            name: "Online Master of Commerce",
            url: "/master-of-commerce-online-degree",
          },
          {
            name: "Online Master of Computer Application",
            url: "/masters-computer-application-online-degree",
          },
          {
            name: "Online Master of Arts ",
            url: "/master-of-arts-online-degree",
          },
        ],
        bachelorDegrees: [
          {
            name: "Online Bachelor of Business Administration",
            url: "bachelors-business-administration-online-degree",
          },
          {
            name: "Online Bachelor of Commerce",
            url: "bachelor-of-commerce-online-degree",
          },
          {
            name: "Online Bachelor of Computer Application",
            url: "bachelor-of-computer-application-online-degree",
          },
        ],
        mbaPrograms: [
          { name: "Online MBA in Finance", url: "/online-mba/finance" },
          {
            name: "Online MBA in Business Intelligence & Analytics",
            url: "/online-mba/business-intelligence-and-analytics",
          },
          {
            name: "Online MBA in Project Management",
            url: "/online-mba/project-management",
          },
          {
            name: "Online MBA in International Finance",
            url: "/online-mba/international-finance",
          },
          {
            name: "Online MBA in Healthcare Management",
            url: "/online-mba/healthcare-management",
          },
          { name: "Online MBA in HR Finance", url: "/online-mba/hr-finance" },
          {
            name: "Online MBA in Logistics & Supply Chain Management",
            url: "/online-mba/logistic-and-supply-chain-management",
          },
          {
            name: "Online MBA in Human Resource Management",
            url: "/online-mba/human-resources-management",
          },
          {
            name: "Online MBA in Finance & Marketing",
            url: "/online-mba/finance-and-marketing",
          },
        ],
        mcaPrograms: [
          {
            name: "Online MCA in Computer Science & IT",
            url: "/online-mca/computer-science-and-it",
          },
          {
            name: "Online MCA in Cyber Security",
            url: "/online-mca/cyber-security",
          },
          {
            name: "Online MCA in Data Science",
            url: "/online-mca/data-science",
          },
          {
            name: "Online MCA in Artificial Intelligence",
            url: "/online-mca/artificial-intelligence",
          },
          {
            name: "Online MCA in Cloud Computing",
            url: "/online-mca/cloud-computing",
          },
          {
            name: "Online MCA in Full Stack Development",
            url: "/online-mca/full-stack-development",
          },
          {
            name: "Online MCA in Data Analytics",
            url: "/online-mca/data-analytics",
          },
        ],
        mcomPrograms: [
          {
            name: "Online M. Com in Accounting & Finance",
            url: "/online-mcom/accounting-and-finance",
          },
          {
            name: "Online M. Com in International Finance",
            url: "/online-mcom/international-finance",
          },
          {
            name: "M.Com In Professional Accounting and Finance (Accredited by CPA, US)",
            url: "/online-mcom/professional-accounting-and-finance",
          },
        ],
        // maPrograms: [
        //   {
        //     name: "Online MA in English",
        //     url: "/online-ma/english",
        //   },
        //   {
        //     name: "Online MA in Economics",
        //     url: "/online-ma/economics",
        //   },
        //   {
        //     name: "Online MA in Public Policy",
        //     url: "/online-ma/public-policy",
        //   },
        // ],
        bbaPrograms: [
          {
            name: "BBA in Data Science & Analytics Course Online",
            url: "/online-bba/data-science-and-analytics",
          },
          {
            name: "BBA in Digital Marketing Course Online",
            url: "/online-bba/digital-marketing",
          },
          {
            name: "BBA in Engineering & Project Management Course Online",
            url: "/online-bba/engineering-and-project-management",
          },
          {
            name: "BBA in Marketing Course Online",
            url: "/online-bba/marketing",
          },
          {
            name: "BBA in Finance Course Online",
            url: "/online-bba/finance",
          },
          {
            name: "BBA in Human Resource Management Course Online",
            url: "/online-bba/human-resources-management",
          },
        ],
        bcaPrograms: [
          {
            name: "BCA in Computer Science & Information Technology",
            url: "/online-bca/computer-science-and-information-technology",
          },
          {
            name: "BCA in Artificial Intelligence",
            url: "/online-bca/artificial-Intelligence",
          },
          {
            name: " BCA in Cyber Security",
            url: "/online-bca/cyber-security",
          },
          {
            name: "BCA in Data Science & Analytics",
            url: "/online-bca/data-science-and-analytics",
          },
          {
            name: "BCA in Cloud Computing",
            url: "/online-bca/cloud-computing",
          },
        ],
        bcomPrograms: [
          {
            name: "Online B. Com Accounting & Finance",
            url: "/online-bcom/accounting-and-finance",
          },
          // {
          //   name: "Online B. Com in Corporate Accounting",
          //   url: "/online-bcom/corporate-accounting",
          // },
          {
            name: "Online B. Com in International Finance & Accounting",
            url: "/online-bcom/international-finance-and-accounting",
          },
        ],
      },
      dataSet3: {
        degrees: [
          {
            name: "Master of Business Administration Degree",
            url: "/master-business-administration-online-degree",
          },
          {
            name: "Master of Commerce Degree",
            url: "/master-of-commerce-online-degree",
          },
          {
            name: "Master of Computer Application Degree",
            url: "/masters-computer-application-online-degree",
          },
        ],
        bachelorDegrees: [
          {
            name: "Bachelor of Business Administration Degree",
            url: "/bachelor-of-business-administration-online-degree",
          },
          {
            name: "Bachelor of Commerce Degree",
            url: "/bachelor-of-commerce-online-degree",
          },
          {
            name: "Bachelor of Computer Application Degree",
            url: "/bachelor-of-computer-application-online-degree",
          },
        ],
        mbaPrograms: [
          { name: "MBA Finance Degree", url: "/online-mba/finance" },
          {
            name: "MBA Business Intelligence & Analytics Degree",
            url: "/online-mba/business-intelligence-and-analytics",
          },
          {
            name: "MBA Project Management Degree",
            url: "/online-mba/project-management",
          },
          {
            name: "MBA International Finance Degree",
            url: "/online-mba/international-finance",
          },
          { name: "MBA Data Science Degree", url: "/online-mba/data-science" },
          {
            name: "MBA Healthcare Management Degree",
            url: "/online-mba/healthcare-management",
          },
          { name: "MBA HR Finance Degree", url: "/online-mba/hr-finance" },
          {
            name: "MBA Logistics & Supply Chain Management Degree",
            url: "/online-mba/logistic-and-supply-chain-management",
          },
          {
            name: "MBA Human Resource Management Degree",
            url: "/online-mba/human-resources-management",
          },
          {
            name: "MBA Finance & Marketing Degree",
            url: "/online-mba/finance-and-marketing",
          },
        ],
        mcaPrograms: [
          {
            name: "MCA Computer Science & IT Degree",
            url: "/online-mca/computer-science-and-it",
          },
          {
            name: "MCA Cyber Security Degree",
            url: "/online-mca/cyber-security",
          },
          { name: "MCA Data Science Degree", url: "/online-mca/data-science" },
          {
            name: "MCA Artificial Intelligence Degree",
            url: "/online-mca/artificial-intelligence",
          },
          {
            name: "MCA Cloud Computing Degree",
            url: "/online-mca/cloud-computing",
          },
          {
            name: "MCA Full Stack Development Degree",
            url: "/online-mca/full-stack-development",
          },
          {
            name: "MCA Data Analytics Degree",
            url: "/online-mca/data-analytics",
          },
        ],
        mcomPrograms: [
          {
            name: "M.Com Accounting & Finance Degree",
            url: "/online-mcom/accounting-and-finance",
          },
          {
            name: "M. Com International Finance Degree",
            url: "/online-mcom/international-finance",
          },
          {
            name: "M.Com In Professional Accounting and Finance (Accredited by CPA, US)",
            url: "/online-mcom/professional-accounting-and-finance",
          },
        ],
        // maPrograms: [
        //   {
        //     name: "MA in English",
        //     url: "/online-ma/english",
        //   },
        //   {
        //     name: "MA in Economics",
        //     url: "/online-ma/economics",
        //   },
        //   {
        //     name: "MA in Public Policy",
        //     url: "/online-ma/public-policy",
        //   },
        // ],
        bbaPrograms: [
          {
            name: "BBA in Data Science & Analytics Course Online",
            url: "/online-bba/data-science-and-analytics",
          },
          {
            name: "BBA in Digital Marketing Course Online",
            url: "/online-bba/digital-marketing",
          },
          {
            name: "BBA in Engineering & Project Management Course Online",
            url: "/online-bba/engineering-and-project-management",
          },
          {
            name: "BBA in Marketing Course Online",
            url: "/online-bba/marketing",
          },
          {
            name: "BBA in Finance Course Online",
            url: "/online-bba/finance",
          },
          {
            name: "BBA in Human Resource Management Course Online",
            url: "/online-bba/human-resources-management",
          },
        ],
        bcaPrograms: [
          {
            name: "BCA in Computer Science & Information Technology",
            url: "/online-bca/computer-science-and-information-technology",
          },
          {
            name: "BCA in Artificial Intelligence",
            url: "/online-bca/artificial-Intelligence",
          },
          {
            name: " BCA in Cyber Security",
            url: "/online-bca/cyber-security",
          },
          {
            name: "BCA in Data Science & Analytics",
            url: "/online-bca/data-science-and-analytics",
          },
          {
            name: "BCA in Cloud Computing",
            url: "/online-bca/cloud-computing",
          },
        ],
        bcomPrograms: [
          {
            name: "B. Com Accounting & Finance Degree",
            url: "/online-bcom/accounting-and-finance",
          },
          {
            name: "B. Com Corporate Accounting Degree",
            url: "/online-bcom/corporate-accounting",
          },
          {
            name: "B. Com International Finance & Accounting Degree",
            url: "/online-bcom/international-finance-and-accounting",
          },
        ],
      },
    };
  },
  components: {
    DisclaimerVue,
    BrochureView,
    // DownloadBrochureVue,
  },
  async mounted() {
    let current_url = this.$route.fullPath;
    this.template_url_list.forEach((el) => {
      if (el.url == current_url) {
        this.template_tab = el.temp_tab;
      }
    });
  },
  methods: {
    toggleTab(tabId) {
      if (this.activefooterTab === tabId) {
        this.activefooterTab = null;
      } else {
        this.activefooterTab = tabId;
      }
    },
    toggleDropdown(type) {
      this.dropdownOpen[type] = !this.dropdownOpen[type];
    },
    handleLinkClick(title, url, sectionName) {
      // Push data to the data layer
      window.dataLayer.push({
        event: "Menu Clicked",
        Attribute: {
          Title: title,
          ID: "",
          "Menu Page URL": url,
          "Section Name": sectionName,
        },
      });
    },
    handleBookAppointment() {
      // Push data to dataLayer and then open appointment iframe
      window.dataLayer.push({
        event: "Menu Clicked",
        Attribute: {
          Title: "Book an Appointment",
          ID: "",
          "Menu Page URL": "",
          "Section Name": "Contact Us",
        },
      });
      this.openAppointment();
    },
    openAppointment() {
      this.videoButton = true;
    },
    closeAppointment() {
      this.videoButton = false;
    },
    handleDownloadBrochure() {
      // Push data to dataLayer and then open download brochure
      window.dataLayer.push({
        event: "Menu Clicked",
        Attribute: {
          Title: "Download Brochure",
          ID: "",
          "Menu Page URL": "",
          "Section Name": "Online Support",
        },
      });
      this.is_download_brochure = true;
    },
    pushBrochureDownloadDataLayer(data) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "Brochure Download Clicked",
        Attribute: {
          "Elective Title": data.electiveTitle,
          "Elective ID": "",
          Program: "",
          "Program ID": "",
          Domain: "",
          "Domain ID": "",
          "Elective Details": "",
          Duration: "",
          "Batch Start Date": "",
          "CTA Section": data.ctaSection,
        },
      });
    },
  },
  updated() {
    console.log(this.videoButton, "here");
  },
};
</script>
<style scoped>
.program-category:not(:last-child) .text-white::after {
  padding-right: 20px;
}
</style>
